import React, { Fragment, useEffect, useState } from "react";
import styles from "./locationList.module.scss";
import DropdownIcon from "../../assets/images/arrow-square-down.svg";
import SortIcon from "../../assets/images/sort-icon.svg";
import AddLocationModal from "./LocationModals/AddLocationModal";
import EditTableIcon from "../../assets/images/edit-table-icon.svg";
import LocationDetailModal from "./LocationModals/LocationDetails";
import NoLocationIcon from "../../assets/images/no-location-icon.svg";
import DataTableComponent from "../Shared/Table";
import { useDispatch, useSelector } from "react-redux";
import {
  clearSearch,
  searchLocations,
  sortLocations,
} from "../Redux/Reducer/appReducer";
import CuteMascotSpinner from "../../global/CuteMascotSpinner";
import PageHeader from "../../global/PageHeader/PageHeader";

const LocationList = () => {
  const dispatch = useDispatch();
  const { locations, locationSearchResults, brands } = useSelector(
    (state) => state?.appReducer
  );

  const [openModal, setOpenModal] = useState(false);
  const [locationId, setLocationId] = useState(0);
  const [openLocationModal, setOpenLocationModal] = useState(false);
  const [editLocationData, setEditLocationData] = useState({});
  const [loading, setLoading] = useState(false);

  const noLocations = !locations?.length;
  const noBrands = brands?.length;

  const tableData = (locationSearchResults || []).map((data) => ({
    ...data,
    action: EditTableIcon,
  }));

  const sortOptions = [
    "Alphabetical (A-Z)",
    "Number of Spots",
    "Brand Name (A-Z)",
  ];

  const toggleModal = () => setOpenModal(!openModal);
  const toggleLocationModal = () => setOpenLocationModal(!openLocationModal);

  const openEditLocationModal = (data) => {
    setEditLocationData(data);
    setOpenModal(true);
  };

  useEffect(() => {
    if (!openModal) {
      setEditLocationData({});
    }
  }, [openModal]);

  const handleSearch = (e) => {
    const query = e.target.value;
    if (query.trim() === "") {
      dispatch(clearSearch());
    } else {
      dispatch(searchLocations(query));
    }
  };

  const handleSort = (sortOption) => {
    dispatch(sortLocations(sortOption));
  };

  const locationColumns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: false,
      center: false,
      wrap: true,
      minWidth: "12%",
      maxWidth: "25%",
      cell: (row) => (
        <div style={{ width: "100%" }}>
          <p>{row.name}</p>
        </div>
      ),
    },
    {
      name: "Location Number",
      selector: (row) => row.globalLocationNumber,
      sortable: false,
      center: true,
      wrap: true,
      minWidth: "20%",
      maxWidth: "25%",
    },
    {
      name: "Brand",
      selector: (row) => row.brand,
      sortable: false,
      center: true,
      wrap: true,
      minWidth: "20%",
      maxWidth: "25%",
    },
    {
      name: "Country",
      selector: (row) => row.country,
      sortable: false,
      center: true,
      minWidth: "15%",
      maxWidth: "20%",
    },
    {
      name: "",
      selector: (row) => row.action,
      center: false,
      minWidth: "5%",
      maxWidth: "5%",
      cell: (row) => (
        <img
          src={row?.action}
          alt="icon"
          width={24}
          height={24}
          onClick={() => openEditLocationModal(row)}
          style={{ cursor: "pointer" }}
        />
      ),
    },
  ];

  return (
    <Fragment>
      {loading && <CuteMascotSpinner />}
      <AddLocationModal
        openModal={openModal}
        toggle={toggleModal}
        editLocationData={editLocationData}
        setLoading={setLoading}
      />
      <LocationDetailModal
        locationId={locationId}
        openModal={openLocationModal}
        toggle={toggleLocationModal}
        setLoading={setLoading}
      />
      <div
        className={`${styles.location_div} ${
          noLocations ? styles.full_height : styles.auto_height
        }`}
      >
        <div className={styles.location_inner}>
          <div className={styles._page_header_wrapper}>
            <PageHeader
              title="Locations"
              sortOptions={sortOptions}
              onSearch={handleSearch}
              onSort={handleSort}
              onAdd={() => setOpenModal(true)}
              addButtonLabel="Add Location"
              SortIcon={SortIcon}
              DropdownIcon={DropdownIcon}
            />
          </div>

          {locationSearchResults?.length !== 0 && (
            <div className={styles.table_container}>
              <DataTableComponent
                tableColumns={locationColumns}
                tableData={tableData}
                highlightOnHover
                onRowClicked={(rowData) => {
                  setLocationId(rowData?.id);
                  setOpenLocationModal(true);
                }}
                tableCustomStyles={{
                  cells: {
                    style: {
                      justifyContent: "center",
                      display: "flex",
                      "&:last-child": {
                        justifyContent: "flex-start",
                      },
                    },
                  },
                }}
              />
            </div>
          )}

          {noLocations && (
            <div className={styles.no_location_layout}>
              <div>
                <img src={NoLocationIcon} alt="no-loc" width={80} height={80} />
              </div>
              <div style={{ marginTop: "24px", marginBottom: "16px" }}>
                <p className={styles.no_location_header}>Locations</p>
              </div>
              <div style={{ marginBottom: "30px" }}>
                <p className={styles.no_location_paragraph}>
                  Please add a Brand, just started using locations.
                </p>
              </div>
              <button
                className={styles.add_button}
                onClick={() => setOpenModal(true)}
                disabled={!noBrands}
              >
                Add location{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M6 12H18"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 18V6"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default LocationList;
